import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { RadioOptionsWithConfirm, IQuestion, CardContainer, CardWithModal } from 'shared-components';

import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import Deportations from './deportations';
import { IDeportation } from '../../../../../types';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';

const VisaPrepFormAddHistoryPage7 = (_props: any) => {
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE2_7));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);
  // state props from store
  const hasBeenDeported = useSelector(({ student }: ApplicationState) => student.visa.hasBeenDeported, shallowEqual);

  const defaultArr = useMemo(() => {
    return [];
  }, []);
  const deportations =
    useSelector(({ student }: ApplicationState) => student.visa.deportations, shallowEqual) || defaultArr;

  // constants
  const currentStep = 7;
  const steps = 8;

  // component state
  const [complete, setComplete] = useState(false);
  const [deportationsState, setDeportationsState] = useState<IDeportation[]>([]);
  const [showModal, setShowModal] = useState<boolean[]>([]);

  useEffect(() => {
    setDeportationsState([
      ...deportations,
      {
        country: '',
        removalDate: '',
        reason: '',
        airport: '',
      },
    ]);
    setShowModal([...deportations.map(_ => false), false]);
  }, [deportations]);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      hasBeenDeported,
      deportations,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, hasBeenDeported, deportations]);

  const toggleModal = (index: number) => {
    setShowModal(showModal.map((value, i) => (i === index ? !value : value)));
  };

  const deleteDeportation = (index: number): void => {
    onChange(VQ.DEPORTATIONS, [...deportations.slice(0, index), ...deportations.slice(index + 1)]);
  };

  const onHasBeenDeportedClick = (question: IQuestion) => {
    onChange(VQ.HAS_BEEN_DEPORTED, question.label === 'Yes');
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Additional History'}
    >
      <RadioOptionsWithConfirm
        key={VQ.HAS_BEEN_DEPORTED}
        id={VQ.HAS_BEEN_DEPORTED}
        label={
          'Have you been deported, removed or otherwise required to leave any country including the UK in the last 10 years?'
        }
        onClick={(question: any) => onHasBeenDeportedClick(question)}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasBeenDeported === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasBeenDeported === false,
          },
        ]}
      />

      {hasBeenDeported === true ? (
        <CardContainer title={`How many times?`}>
          {deportationsState.map((deportation: IDeportation, index: number) => (
            <CardWithModal
              key={index}
              id={`deportations-${index}`}
              index={index}
              modalTitle={'Add Deportation'}
              cardItems={[
                {
                  label: 'Country',
                  value: deportation.country,
                },
                {
                  label: 'Date of deportation',
                  value: deportation.removalDate,
                },
                {
                  label: 'Port or airport',
                  value: deportation.airport,
                },
                {
                  label: 'Reason of deportation',
                  value: deportation.reason,
                },
              ]}
              onRemove={deleteDeportation}
              addButtonLabel={`Add Deportation`}
              addAnotherButtonLabel={`I have another Deportation to add`}
              hasAddMoreButton={
                deportation.country === '' &&
                deportation.removalDate === '' &&
                deportation.airport === '' &&
                deportation.reason === ''
              }
              showModal={showModal[index]}
              toggleModal={toggleModal}
            >
              <Deportations
                index={index}
                country={deportation.country}
                removalDate={deportation.removalDate}
                airport={deportation.airport}
                reason={deportation.reason}
                onSaveAndClose={(deportation: IDeportation) => {
                  const deportationsNew = [...deportations];
                  deportationsNew[index] = {
                    ...deportation,
                  };
                  onChange(VQ.DEPORTATIONS, deportationsNew);
                  toggleModal(index);
                }}
              />
            </CardWithModal>
          ))}
        </CardContainer>
      ) : null}
    </QuestionPage>
  );
};
export default VisaPrepFormAddHistoryPage7;
